import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results"]

  connect() {
    this.timeout = null
  }

  search() {
    clearTimeout(this.timeout)
    const query = this.inputTarget.value.trim()

    if (query.length < 2) {
      this.resultsTarget.innerHTML = ""
      this.resultsTarget.removeAttribute("src")
      return
    }

    this.timeout = setTimeout(() => {
      this.resultsTarget.src = `/movies?query=${encodeURIComponent(query)}`
    }, 300)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
